import { Box, Container, Grid } from "@vapor/react-material";
import CssBaseline from "@vapor/react-material/CssBaseline";

import { LoginPageDto } from "../dtos/LoginPageDto";
import Footer from "./footer";

import HeaderBar from "./header-bar";
import LoginForm from "./login-form";
import AdvertisingChildren from "./advertising-children";

const LoginPage = (props: LoginPageDto) => {
    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={{
                minHeight: "100vh",
            }}
        >
            <CssBaseline />
            <HeaderBar />
            <Grid container>
                <Grid
                    item
                    xs={4}
                    sx={{
                        minHeight: "calc(100vh - 4rem)",
                        padding: { md: " 2.5rem 1rem", lg: "2.5rem", xl: "3.5rem" },
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    }}
                >
                    <LoginForm
                        appName={props.appName}
                        loginButtonLabel={props.loginButtonLabel}
                        logo={props.logo}
                    />
                    <Footer
                        cookiePolicyUrl={props.cookiePolicyUrl}
                        privacyPolicyUrl={props.privacyPolicyUrl}
                    />
                </Grid>
                <Grid
                    item
                    xs={8}
                    sx={{
                        minHeight: "calc(100vh - 4rem)",
                        height: "100%",
                        backgroundColor: "#f2f5f8",
                        backgroundImage:
                            "url(https://appdev.teamsystemdigital.com/images/ts-digital/prelogin/bgblue.svg)",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Box
                        sx={{
                            background:
                                "linear-gradient(0deg, rgba(243, 246, 249, 0) 0%, rgba(255, 255, 255, 0.7) 100%)",
                            borderRadius: "0.5rem",
                            padding: "3rem",
                            margin: "2rem",
                            maxWidth: "869px",
                            position: "relative",
                        }}
                    >
                        <AdvertisingChildren />
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default LoginPage;
